import {Injectable} from '@angular/core';
import {BehaviorSubject, ReplaySubject} from "rxjs";
import {UserModel} from "./models/user/user.model";
import {ICommonAppSettings} from "./config.service";

@Injectable({
  providedIn: 'root'
})
export class BaseStateService {
  public isHelpModeActivated$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public currentUser$: BehaviorSubject<UserModel> = new BehaviorSubject<UserModel>(null);
  public settings$: ReplaySubject<ICommonAppSettings> = new ReplaySubject<ICommonAppSettings>();

  constructor() {
  }

  toggleHelpMode() {
    this.isHelpModeActivated$.next(!this.isHelpModeActivated$.value);
  }
}
